/* Tasi redesign — homepage behaviour (sections/tasi-home-products.liquid).
   Filter tabs: [data-thm-tabs] root, role="tab" buttons with aria-controls → role="tabpanel".
   No reload; keyboard: ←/→/Home/End (WAI-ARIA tabs, automatic activation). */
(function () {
	function initTabs(root) {
		if (root.dataset.thmTabsReady) return;
		root.dataset.thmTabsReady = '1';
		const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
		if (!tabs.length) return;

		const select = (tab, focus) => {
			tabs.forEach((t) => {
				const on = t === tab;
				t.setAttribute('aria-selected', on ? 'true' : 'false');
				t.tabIndex = on ? 0 : -1;
				const panel = document.getElementById(t.getAttribute('aria-controls'));
				if (panel) panel.hidden = !on;
			});
			if (focus) tab.focus();
		};

		tabs.forEach((tab, i) => {
			tab.addEventListener('click', () => select(tab, false));
			tab.addEventListener('keydown', (e) => {
				let next = null;
				if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
				else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
				else if (e.key === 'Home') next = tabs[0];
				else if (e.key === 'End') next = tabs[tabs.length - 1];
				if (next) { e.preventDefault(); select(next, true); }
			});
		});
	}

	function init(scope) {
		(scope || document).querySelectorAll('[data-thm-tabs]').forEach(initTabs);
		if (window.TasiWish && typeof window.TasiWish.sync === 'function') window.TasiWish.sync();
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
	else init();

	// Theme editor: re-init when a section is re-rendered; show the selected tab block.
	document.addEventListener('shopify:section:load', (e) => init(e.target));
	document.addEventListener('shopify:block:select', (e) => {
		const tab = e.target.closest && e.target.closest('[role="tab"]');
		if (tab) tab.click();
	});
})();
